import { useCallback } from 'react';

const KV_REST_API_URL = process.env.NEXT_PUBLIC_KV_REST_API_URL;
const KV_REST_API_TOKEN = process.env.NEXT_PUBLIC_KV_REST_API_TOKEN;

function useKv() {
  const setKV = useCallback(
    async ({
      key,
      value,
      type,
      expirySeconds,
    }: {
      key: string;
      value: string | boolean | number;
      type?: string;
      // When provided, the backend should apply a TTL so stale keys don't accumulate.
      expirySeconds?: number;
    }) => {
      try {
        const hasValidExpiry =
          typeof expirySeconds === 'number' && Number.isInteger(expirySeconds) && expirySeconds > 0;
        const d = await fetch(`${KV_REST_API_URL}/set/${key}`, {
          headers: {
            Authorization: `Bearer ${KV_REST_API_TOKEN}`,
          },
          body: JSON.stringify({
            value,
            type,
            ...(hasValidExpiry ? { ex: expirySeconds } : {}),
          }),
          method: 'POST',
        })
          .then((response) => response.json())
          .then((data) => data);
        return d;
      } catch (error) {
        console.error(`Error setting data`, error);
        return null;
      }
    },
    []
  );

  const getKV = useCallback(async (key: string) => {
    if (!key) return { value: '', param: key };
    try {
      const value: { value: string; type: string } = await fetch(`${KV_REST_API_URL}/get/${key}`, {
        headers: {
          Authorization: `Bearer ${KV_REST_API_TOKEN}`,
        },
      })
        .then((response) => response.json())
        .then((data) => JSON.parse(data.result));
      return { ...value, param: key };
    } catch (error) {
      console.error(`error getting value`, { error, key });
      return null;
    }
  }, []);

  return { setKV, getKV };
}

export default useKv;
